var map = {
	"./bigwin.png": 649920,
	"./coinApng.png": 6537,
	"./epicwin.png": 484637,
	"./grandjackpot.png": 678120,
	"./grandjackpot星星.png": 668942,
	"./hugewin.png": 952387,
	"./majorjackpot.png": 599335,
	"./majorjackpot火焰.png": 311566,
	"./massivewin.png": 618652,
	"./minijackpot.png": 850031,
	"./minijackpot火焰.png": 187270,
	"./superwin.png": 636657,
	"./ultimatewin.png": 624063,
	"./星星.png": 65846,
	"./树叶.png": 159653,
	"./火光.png": 622964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706715;